import React, { useEffect, useRef, useState } from 'react'; //import React Component
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { cloudStore, storage } from '../firebase';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { collection, query, where, setDoc, doc, getDocs } from 'firebase/firestore';

export function AddWelcome() {
    const [pic, setpic] = useState("")
    const [title, settitle] = useState("")
    const [intro, setintro] = useState("")
    const [detail, setdetail] = useState("")
    const imageRef = useRef(null);
    const picRef = useRef("");
    const titleRef = useRef("");
    const introRef = useRef("");
    const detailRef = useRef("");
    const metadata = {
        contentType: "image/jpeg"
    }; //Image type
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        const image = imageRef.current;
        if (id === "pic") {
            if (image.value.length > 0) {
                picRef.current.style.color = "black"
            }
            var divsToRemove = document.querySelectorAll(".resize");
            if (divsToRemove.length > 0) {
                for (var i = 0; i < divsToRemove.length; i++) {
                    divsToRemove[i].parentNode.removeChild(divsToRemove[i]);
                }
            }
            if (image.value.length !== 0) {
                setpic(image.files[0]);
                let imgName = image.files[0].name.split(".")[0];
                const tempo = ref(storage, "Tempo_forAddWelcome/" + imgName);
                const uploadTask = uploadBytesResumable(tempo, image.files[0], metadata)
                uploadTask.on('state_changed',
                    (snapshot) => {
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        const img_tips = document.createElement("div");
                        var text = document.createTextNode('Upload is ' + progress.toFixed(2) + '% done');
                        img_tips.appendChild(text);
                        img_tips.classList.add("img_tips");
                        image.after(img_tips);
                        setTimeout(() => { img_tips.classList.add("disappear") }, 3000);
                    },
                    (error) => {
                        console.log(error);
                    },
                    () => {
                        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                            const img = document.createElement("img");
                            img.classList.add("resize");
                            img.src = downloadURL;
                            img.id = pic.name;
                            image.after(img);
                        });
                    }
                );
            }
        }
        if (id === "title") {
            settitle(value)
            if (value.trim().length > 0) {
                titleRef.current.style.color = "black"
            }
        }
        if (id === "intro") {
            setintro(value)
            if (value.trim().length > 0) {
                introRef.current.style.color = "black"
            }
        }
        if (id === "detail") {
            setdetail(value)
            if (value.trim().length > 0) {
                detailRef.current.style.color = "black"
            }
        }
    }

    const [data, setdata] = useState([])
    useEffect(() => {
        if (data.length === 0) {
            getDocs(query(collection(cloudStore, "welcomeBoard"), where("Post_Content", "!=", null)))
                .then((querySnapshot) => {
                    const newInfoArray = querySnapshot.docs.map(doc => doc.data());
                    setdata(newInfoArray);
                })
        }
    })

    //Upload all the data in firebase
    //Also show error when recieved error input
    const add_welcome = async () => {
        const 这个是二级保证 = localStorage.getItem("这个是二级保证");
        const userName = localStorage.getItem("currentLoginUser");
        const userExist = await getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.name", "==", userName)));
        const userData = userExist.docs.map(doc => doc.data());
        const image = document.querySelector(".uploadImg");
        var newDiv = document.createElement("div");
        var text = "";
        newDiv.classList.add("tips");
        setTimeout(() => { newDiv.classList.add("disappear") }, 4500);
        let button = document.querySelector(".welcomeButton");
        let boardID = getRandomInt(1000, 9999).toString() + title
        if (userData[0]) {
            if (userData[0].officer === true && 这个是二级保证 === "true") {
                if (detail.length !== 0 && intro.length !== 0 && title.length !== 0 && image.value.length !== 0 && detail.trim().length > 0
                    && intro.trim().length > 0 && title.trim().length > 0) {
                    if (data.length >= 4) {
                        text = document.createTextNode("公告上限4个，请删除后添加。");
                        newDiv.appendChild(text);
                        button.after(newDiv);
                    } else {
                        const storageRef = ref(storage, "WelcomeBoard Image/" + title + userName);
                        image.value = null
                        if (document.querySelector(".resize")) {
                            document.querySelector(".resize").style.display = "none";
                            var divsToRemove = document.querySelectorAll(".resize");
                            if (divsToRemove.length > 0) {
                                for (var i = 0; i < divsToRemove.length; i++) {
                                    divsToRemove[i].parentNode.removeChild(divsToRemove[i]);
                                }
                            }
                        }

                        uploadBytesResumable(storageRef, pic, metadata).then(() => { //Store img
                            getDownloadURL(storageRef).then(async (downloadURL) => {
                                const docData = {
                                    "Post_Content": {
                                        pic: downloadURL,
                                        title: title,
                                        intro: intro,
                                        detail: detail,
                                        date: new Date(),
                                        boardID: boardID
                                    }
                                }
                                setDoc(doc(cloudStore, "welcomeBoard", boardID), docData).then(() => {
                                    var newDiv2 = document.createElement("div");
                                    var text = document.createTextNode(" Finished Processing");
                                    newDiv2.classList.add("tips");
                                    newDiv2.appendChild(text);
                                    newDiv2.style.color = "red"
                                    button.after(newDiv2);
                                    setTimeout(() => { window.location.reload() }, 500);
                                })
                            })
                        });
                        text = document.createTextNode("Wait for Processing. Do not Reflesh the page utill you saw the finish message");
                        newDiv.appendChild(text);
                        button.after(newDiv);
                    }
                } else {
                    text = document.createTextNode("Please fillout the important blanks.");
                    newDiv.appendChild(text);
                    button.after(newDiv);
                    if (image.value.length === 0) {
                        picRef.current.style.color = "red"
                    }
                    if (title.length === 0) {
                        titleRef.current.style.color = "red"
                    }
                    if (intro.length === 0) {
                        introRef.current.style.color = "red"
                    }
                    if (detail.length === 0) {
                        detailRef.current.style.color = "red"
                    }
                }
            } else {
                text = document.createTextNode("You are not officer.");
                newDiv.appendChild(text);
                button.after(newDiv);
            }
        } else {
            text = document.createTextNode("You have not signin.");
            newDiv.appendChild(text);
            button.after(newDiv);
        }

    }

    return (
        <div id='addWelcome'>
            <Navigation />
            <main>
                <div className="add">
                    <h1 className="title">Create a Welcome Content</h1>
                    <form>
                        <label htmlFor="pic" ref={picRef}>Picture: </label>
                        <input
                            className='uploadImg'
                            type="file"
                            id="pic"
                            accept="image/jpeg, image/png, image/jpg"
                            style={{ maxWidth: "360px", border: "none" }}
                            onChange={(e) => { handleInputChange(e) }}
                            ref={imageRef}
                        />
                        <br />
                        <label htmlFor="title" ref={titleRef}>Post Title: </label>
                        <input
                            type="text"
                            id="title"
                            placeholder="Write Welcome Title."
                            onChange={(e) => { handleInputChange(e) }}
                            value={title}
                        />
                        <label htmlFor="intro" ref={introRef}>Post Intro: </label>
                        <input
                            type="text"
                            id="intro"
                            placeholder="Write Welcome Intro."
                            onChange={(e) => { handleInputChange(e) }}
                            value={intro}
                        />
                        <label htmlFor="detail" ref={detailRef}>Post Detail: </label>
                        <textarea
                            type="text"
                            id="detail"
                            placeholder="Write Welcome Detail."
                            onChange={(e) => { handleInputChange(e) }}
                            value={detail}
                        ></textarea>
                        <div className='button welcomeButton' onClick={add_welcome} style={{ marginTop: "20px" }}>Submit</div>
                    </form>
                </div>
            </main>
            <Footer />
        </div>
    );
}

function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
} 